export default "//static.tradera.net/touchweb/static/output/images/network-fb.fb8fde4a.svg";